module.exports = __webpack_public_path__ + "img/thumb-tiny-image-2.c26a07e1.png";